import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Flag, X } from "lucide-react";
import { useGiveawayState } from "@/lib/useGiveaway";

export default function GiveawayBanner() {
  const { data } = useGiveawayState();
  const [closed, setClosed] = useState(() => sessionStorage.getItem("vg_banner_closed") === "1");
  const phase = data?.phase;
  if (closed || !["teaser", "voting"].includes(phase)) return null;
  const msg =
    phase === "voting"
      ? "Veteran HVAC Giveaway — Nominations & Voting are OPEN through October 31"
      : "Veteran HVAC Giveaway — Nominations & Voting Open October 1–31, 2026";
  return (
    <div className="bg-[#0a1730] text-white border-b border-launch/40" data-testid="giveaway-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-center relative">
        <Flag className="h-4 w-4 text-launch flex-shrink-0" />
        <Link to="/veteran-hvac-giveaway" aria-label="Learn more about the Veteran HVAC Giveaway" className="text-xs sm:text-sm font-bold hover:text-launch transition-colors">
          {msg} <span className="underline">Learn More →</span>
        </Link>
        <button
          onClick={() => { sessionStorage.setItem("vg_banner_closed", "1"); setClosed(true); }}
          className="absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center min-h-[48px] min-w-[48px] text-slate-400 hover:text-white"
          aria-label="Dismiss giveaway banner"
          data-testid="giveaway-banner-close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
